<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="prev-page pr-1 prev"><a routerLink="/vendor-details/{{vendorId}}">Vendor Details</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Vendor Reviews</span>
        <!-- <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Plant Details</span> -->
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Vendor Reviews</h2>
    </div>

    <div class="filter_bar border-top border-bottom border-light mb-4 mb-md-5 mx-n5 px-5">
        <div class="row">

            <div class="col-12 col-md-6 col-lg-3 py-2 py-md-3 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/sort_cyan.svg" class="field_icon"></svg-icon>
                <div [autoClose]="'outside'" [ngbPopover]="popContentfilter" triggers="manual" #q="ngbPopover"
                    (click)="openPopoverReceived(q)" (clickOutside)="onClickedOutside($event)" placement="bottom"
                    popoverClass="search_select_popover" class='py-0 px-0 w-100 pl-3'>
                    <span class="_popover_label">Reviews Received On</span>
                    <span class="d-flex justify-content-end _popover_arrow">
                        <img src="/assets/images/Path.png" class="padding-left-image pr-3 justify-content-between" />
                    </span>
                    <div class="all">{{selectedReviewFilterName}}</div>
                    <ng-template #popContentfilter>
                        <div class="popover_search">
                            <svg-icon src="/assets/images/icons/search.svg"></svg-icon>
                            <input type="text" placeholder='Search' [(ngModel)]="searchGroup" />
                        </div>
                        <div class="popover_content">
                            <div class="popover_items">
                                <div class="popover_item d-flex align-items-center justify-content-between"
                                    *ngFor="let groupf of getFilteredReviewFilterTypes(); let i=index"
                                    [ngClass]="(multiSelectGroupFilter == groupf?.reviewTypeFilterName || (groupf.reviewTypeFilterName == null && multiSelectGroupFilter.length == 0)) && 'active'"
                                    (click)="selectFilterType(groupf)">
                                    {{groupf?.reviewTypeFilterName}}
                                    <svg-icon src="/assets/images/icons/tick.svg"
                                        *ngIf="multiSelectGroupFilter == groupf?.reviewTypeFilterName || (groupf.reviewTypeFilterName == null && multiSelectGroupFilter.length == 0)"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3 py-2 py-md-3 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/sort_cyan.svg" class="field_icon"></svg-icon>
                <div [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual" #p="ngbPopover"
                    (click)="openPopover(p)" (clickOutside)="onClickedOutside($event)" placement="bottom"
                    popoverClass="search_select_popover" class='py-0 px-0 w-100 pl-3'>
                    <span class="_popover_label">Review</span>
                    <span class="d-flex justify-content-end _popover_arrow">
                        <img src="/assets/images/Path.png" class="padding-left-image pr-3 justify-content-between" />
                    </span>
                    <div class="all">{{selectedReviewName}}</div>
                    <ng-template #popContent>
                        <div class="popover_search">
                            <svg-icon src="/assets/images/icons/search.svg"></svg-icon>
                            <input type="text" placeholder='Search' [(ngModel)]="searchGroup" />
                        </div>
                        <div class="popover_content">
                            <div class="popover_items">
                                <div class="popover_item d-flex align-items-center justify-content-between"
                                    *ngFor="let group of getFilteredReviewTypes(); let i=index"
                                    [ngClass]="(multiSelectGroup == group?.reviewTypeName || (group.reviewTypeName == null && multiSelectGroup.length == 0)) && 'active'"
                                    (click)="selectReviewType(group)">
                                    {{group?.reviewTypeName}}
                                    <svg-icon src="/assets/images/icons/tick.svg"
                                        *ngIf="multiSelectGroup == group?.reviewTypeName || (group.reviewTypeName == null && multiSelectGroup.length == 0)"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 py-2 py-md-3 d-flex align-items-center">
                <form class="search_form w-100">
                    <svg-icon src="./assets/images/icons/search.svg"></svg-icon>
                    <input type="text" name="searchText" id="menu-search" class="search_field"
                        placeholder="Type here to search…" [(ngModel)]="searchText" (keyup)="searchByText(searchText)"
                        (search)="searchByText(searchText)">
                    <button type="submit" class="d-none"></button>
                </form>
            </div>
        </div>
    </div>

    <div class="mb-4 mb-md-5 d-flex align-items-center justify-content-between">
        <h3 class="h6 font-weight-bold text-dark">{{totalRows}} Review{{totalRows > 1 ? 's' : null}}</h3>
        <div class="d-flex align align-items-center column-gap-2" *ngIf="foodvendorApprove">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="masterSelectedReview" name="list_name"
                    value="m1" (change)="checkUncheckAll()" id="all_list_name">
                <label class="custom-control-label cursor-pointer" for="all_list_name">Select reviews reported as
                    abuse</label>
            </div>
            <div ngbDropdown *ngIf="showDropdown">
                <button type="button" class="dropdown_dots px-2 text-primary" id="download_dropdown" ngbDropdownToggle>
                    <svg-icon src="../../../assets/images/icons/more_dots.svg"
                        [svgStyle]="{ 'height.px':20 }"></svg-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="download_dropdown">
                    <!-- <button *ngIf="newmainReviewListHide.length==0" ngbDropdownItem
                        (click)="openModalHideReview(onlyReviewIds, 'bulk_hide')">Hide Review</button>
                    <button *ngIf="newmainReviewListHide.length>0" ngbDropdownItem
                        (click)="openModalHideReview(onlyReviewIds, 'bulk_unhide')">Unhide Review</button> -->
                    <button ngbDropdownItem (click)="openModalRemoveReviewFlag(onlyReviewIds)">Remove Flag</button>
                </div>
            </div>
        </div>
    </div>

    <div class="row row-gap-4">
        <div class="col-12" *ngFor="let review of newmainReviewList | paginate: { itemsPerPage: 12,
            currentPage: page, totalItems:newmainReviewList?.length }; let i=index">
            <div class="bg-lighter p-3 rounded d-flex column-gap-2 flex-column">
                <div class="d-flex column-gap-2 mb-2">
                    <div class="custom-control custom-checkbox flex-shrink-0 pointer-event-none" *ngIf="foodvendorApprove">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="review.isSelected"
                            name="list_name" [id]="review.foodCourtVendorReviewId + 'list_name'"
                            value="{{review.foodCourtVendorReviewId}}" (change)="isAllSelected()" [readOnly]="true">
                        <label [for]="review.foodCourtVendorReviewId + 'list_name'"
                            class="custom-control-label pointer-event-none"></label>
                    </div>
                    <div class="d-flex w-100 align-items-center">
                        <p class="mb-0">{{review.reviewDescription}}</p>
                        <div ngbDropdown class="ml-auto" *ngIf="foodvendorApprove">
                            <button type="button" class="dropdown_dots px-2 text-primary" id="download_dropdown"
                                ngbDropdownToggle>
                                <svg-icon src="../../../assets/images/icons/more_dots.svg"
                                    [svgStyle]="{ 'height.px':20 }"></svg-icon>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="download_dropdown">
                                <button *ngIf="review.isReviewHide!=true" ngbDropdownItem
                                    (click)="openModalHideReviewSingle([review.foodCourtVendorReviewId],'hide')">Hide
                                    Review</button>
                                <button *ngIf="review.isReviewHide==true" ngbDropdownItem
                                    (click)="openModalHideReviewSingle([review.foodCourtVendorReviewId],'unhide')">Unhide
                                    Review</button>
                                <button *ngIf="review.isFlagRemove==null && review.isFlagReview==true" ngbDropdownItem
                                    (click)="openModalRemoveReviewFlag([review.foodCourtVendorReviewId])">Remove
                                    Flag</button>
                            </div>
                        </div>
                    </div>
                </div>
                <p *ngIf="review.isFlagRemove==null && review.isFlagReview==true"
                    class="text-danger mb-0 font-weight-semibold small d-flex align-items-center column-gap-2">
                    <svg-icon src="../../../assets/images/icons/error.svg" [svgStyle]="{ 'height.px':16 }"></svg-icon>
                    Reported
                </p>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center pagination-section mt-4" *ngIf="mainReviewList?.length > 12">
        <div class="custom_pagination mt-4 mt-md-5 small">
            <div class="border border-light">
                <pagination-controls class="pagination" (pageChange)="handelReviewList($event)"
                    class="d-flex justify-content-center">
                </pagination-controls>
                <div class="page_numbers">
                    {{indexPage}}/{{paginationCount(mainReviewList?.length)}}</div>
            </div>
        </div>
    </div>
</div>